"use client";

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Comments from "@/components/sidebar/videosidebar/sections/comments";
import Content from "@/components/sidebar/videosidebar/sections/content";
import Notes from "@/components/sidebar/videosidebar/sections/notes";
import DetailSection from "./DetailSection";
import Components from "@/components";
import Partials from "../partials";
import "../player-side.scss";

function SwitchSection() {
  const { comments } = useSelector((state) => state.videobar);
  const { courseInfo, videoInfo, articleInfo } = useSelector(
    (state) => state.video
  );
  const user = useSelector((state) => state.user.users);

  const [activeTab, setActiveTab] = useState("About");

  const [isWarning, setIsWarning] = useState({
    show: false,
    type: "",
    name: "",
    btnClick: "",
  });

  const componentsSwitch = () => {
    if (activeTab === "Next Video")
      return (
        <Content
          isCreator={courseInfo?.creatorId === user._id}
          isMobile={true}
        />
      );
    if (activeTab === "About")
      return (
        <DetailSection
          handleWarning={(fields) =>
            setIsWarning((prev) => ({ ...prev, ...fields }))
          }
          isLoading={!(videoInfo || articleInfo)}
        />
      );
    if (activeTab === "Comments") return <Comments />;

    if (activeTab === "Notes") return <Notes />;

    return (
      <Content isCreator={courseInfo?.creatorId === user._id} isMobile={true} />
    );
  };

  useEffect(() => {
    if (comments) setActiveTab("Comments");
  }, [comments]);

  return (
    <>
      {isWarning.show ? (
        <Components.WarningAlert
          type={isWarning.type}
          onbtnClick={isWarning}
          name={isWarning.name}
          onCancel={() => setIsWarning((prev) => ({ ...prev, show: false }))}
        />
      ) : null}
      <>
        <div className={"vd-divider"} />
        <Partials.Header active={activeTab} setActive={setActiveTab} />
        <div className={"vd-divider"} />
        <article className={"vd-details"}>{componentsSwitch()}</article>
      </>
    </>
  );
}

export default React.memo(SwitchSection);
